module.exports = __webpack_public_path__ + "img/new.0d7ce166.png";